import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from '@/store';

// 类型化的Redux hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// 便捷的选择器hooks
export const useAppState = () => useAppSelector((state) => state.app);
export const useUserState = () => useAppSelector((state) => state.user);
export const useUIState = () => useAppSelector((state) => state.ui);

// 特定状态的hooks
export const useLoading = () => useAppSelector((state) => state.app.loading);
export const useError = () => useAppSelector((state) => state.app.error);
export const useNetworkStatus = () => useAppSelector((state) => state.app.networkStatus);
export const useCurrentUser = () => useAppSelector((state) => state.user.currentUser);
export const useIsAuthenticated = () => useAppSelector((state) => state.user.isAuthenticated);
export const useTheme = () => useAppSelector((state) => state.ui.theme);
export const useNotifications = () => useAppSelector((state) => state.ui.notifications);